/**
 * Display-label helpers for sub-delegate signup copy (plan §7).
 */

import type {
  DelegationPermission,
  SubDelegateOwnerRole,
} from '../types/subDelegateInvite';

const ROLE_LABELS: Record<SubDelegateOwnerRole, string> = {
  CARE_SEEKER: 'Care Seeker',
  SERVICE_PROVIDER: 'Service Provider',
  FINANCIAL_ADVISOR: 'Financial Advisor',
  ADMIN: 'Admin',
};

const PERMISSION_LABELS: Record<DelegationPermission, string> = {
  MESSAGING: 'Messaging',
  EMAIL_NOTIFICATIONS: 'Email Notifications',
  WORKSPACE_OPERATIONS: 'Workspace Operations',
  PROFILE_MANAGEMENT: 'Profile Management',
};

export const ownerRoleLabel = (role: SubDelegateOwnerRole): string =>
  ROLE_LABELS[role] ?? role;

export const permissionLabels = (
  permissions: DelegationPermission[],
): string[] => permissions.map((p) => PERMISSION_LABELS[p] ?? p);

/** Best-effort label for the current user's role (may be any app role). */
export const userRoleLabel = (role?: string): string => {
  if (!role) return 'user';
  const known = ROLE_LABELS[role as SubDelegateOwnerRole];
  if (known) return known;
  return role
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};
